<template>
  <div class="p-2" :class="{...style, 'cursor-pointer' : $attrs.onClick}">
    <div data-testid="innerDiv" class="bg-white shadow-xl rounded-lg p-4 flex flex-col justify-center h-full relative" :class="innerStyle" :style="$attrs.style">
      <slot />
    </div>
  </div>
</template>

<script setup>

import {computed, defineProps} from 'vue';

const props = defineProps({
  numberPerRow: {
    type: Number,
    default: 3,
    validator(value) {
      return [1, 2, 3, 4,5 ].includes(value)
    }
  },
  innerClass: {
    type: String,
    default: ""
  },
  border: {
    type: String,
    required: false
  }
});

const style = {
  "lg:w-1/5 md:w-1/2 w-full": props.numberPerRow === 5,
  "lg:w-1/4 md:w-1/2 w-full": props.numberPerRow === 4,
  "lg:w-1/3 md:w-1/2 w-full": props.numberPerRow === 3,
  "lg:w-1/2 w-full": props.numberPerRow === 2,
  "w-full": props.numberPerRow === 1
}


const innerStyle = computed(() => {
  let classes = props.innerClass || "";

  if(props.border) {
    classes += ` border-2 ${props.border}`;
  }

  return classes;
});

if(props.border) {
  innerStyle.value += ` border-2 ${props.border}`;
}

</script>

<style scoped>

</style>